import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
  forwardRef,
} from '@angular/core';

import {
  ControlValueAccessor,
  FormControl,
  NG_VALUE_ACCESSOR,
  ReactiveFormsModule,
} from '@angular/forms';

import {CommonModule} from '@angular/common';

import {TuiDay, TuiDayRange} from '@taiga-ui/cdk';
import {TuiTextfield} from '@taiga-ui/core';
import {TuiCalendarRange, TuiInputDateRange} from '@taiga-ui/kit';
import {TuiDropdown} from '@taiga-ui/core';

export type DateRange = {
  from: TuiDay | null;
  to: TuiDay | null;
};

@Component({
  standalone: true,
  selector: 'gatewee-datepicker-range',
  imports: [
    CommonModule,
    ReactiveFormsModule,
    TuiInputDateRange,
    TuiCalendarRange,
    TuiTextfield,
    TuiDropdown,
  ],
  templateUrl: './gatewee-datepicker-range.component.html',
  styleUrls: ['./gatewee-datepicker-range.component.css'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => GateweeDatepickerRangeComponent),
      multi: true,
    },
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GateweeDatepickerRangeComponent implements ControlValueAccessor {
  @Input() label = 'Selecione um período';
  @Input() minDate: TuiDay | null = null;
  @Input() maxDate: TuiDay | null = null;
  @Input() required = false;
  @Output() dateChange = new EventEmitter<DateRange>();

  control = new FormControl<TuiDayRange | null>(null);

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  private onChange = (value: TuiDayRange | null) => {};
  private onTouched = () => {};

  disabled = false;

  constructor() {
    this.control.valueChanges.subscribe(value => {
      this.onChange(value);
      this.onTouched();
      // Emit dateChange event for compatibility with filter-head component
      if (value) {
        this.dateChange.emit({
          from: value.from,
          to: value.to,
        });
      } else {
        this.dateChange.emit({
          from: null,
          to: null,
        });
      }
    });
  }

  writeValue(value: TuiDayRange | null): void {
    this.control.setValue(value, {emitEvent: false});
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
    isDisabled
      ? this.control.disable({emitEvent: false})
      : this.control.enable({emitEvent: false});
  }

  registerOnChange(fn: (value: TuiDayRange | null) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }
}
